export default "__VITE_ASSET__4N4UGaK3__"